const formItemInjectionKey = Symbol("ArcoFormItemContext");
const formInjectionKey = Symbol("ArcoFormContext");
export { formInjectionKey, formItemInjectionKey };
